import { useEffect, useRef, useCallback } from 'react';

/**
 * Custom hook for managing keyboard navigation
 * Handles Tab and Enter key navigation between swimlane items
 */
export const useKeyboardNavigation = ({
  tabActive,
  setTabActive,
  swimlaneItems,
  swimlaneIndex,
  setCatStore,
}) => {
  const hasTabBeenPressed = useRef(false);

  const handleKeyDown = useCallback(
    event => {
      if (event.key === 'Tab') {
        // Only process if Tab hasn't been processed yet
        if (hasTabBeenPressed.current) return;

        hasTabBeenPressed.current = true;

        const cat_id = document.getElementById(event.target.id)?.id;
        const next_cat_id = cat_id?.split(',')[0];

        if (next_cat_id === undefined && tabActive === null) {
          document.getElementById(`add-category-${1}`)?.click();
        } else if (next_cat_id === undefined && tabActive !== null) {
          setTimeout(() => {
            document.getElementById(tabActive)?.click();
          }, 0);
        }

        if (
          document.getElementById(
            `add-category-${parseInt(next_cat_id) + 1}`
          ) === null
        ) {
          swimlaneItems?.forEach((item, index) => {
            if (event?.target?.id === `${swimlaneIndex},${index}`) {
              const index_ =
                item?.swimlane_detail_sheets?.length ||
                item?.swimlane_item_detail_sheets?.length;
              setTimeout(() => {
                document?.getElementsByName(`item,${index_}`)[0]?.focus();
              }, 0);
            }
          });
        }

        if (
          document.getElementById(`add-category-${parseInt(next_cat_id) + 1}`)
        ) {
          event.preventDefault();
          setTabActive(`add-category-${parseInt(next_cat_id) + 1}`);
          document
            .getElementById(`add-category-${parseInt(next_cat_id) + 1}`)
            ?.click();
        }
      }

      if (event.key === 'Enter') {
        const index = event.target.id?.split(',')[0];
        const pos = parseInt(event.target.id?.split(',')[1]);
        setCatStore(pos);
        document.getElementById(`add-category-${parseInt(index)}`)?.click();
      }
    },
    [tabActive, setTabActive, swimlaneItems, swimlaneIndex, setCatStore]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    // Reset the hasTabBeenPressed ref when tabActive or swimlaneItems change
    hasTabBeenPressed.current = false;
  }, [tabActive, swimlaneItems]);

  return {
    handleKeyDown,
  };
};
